module.exports = __webpack_public_path__ + "static/media/image.c10fe94e.png";